export default {
    SET_LOADING_STATE: "requiredGear/SET_LOADING_STATE",
    SET_REQUIRED_GEAR_DATA: "requiredGear/SET_REQUIRED_GEAR_DATA",
    SET_DIALOG_STATE: "requiredGear/SET_DIALOG_STATE"
} 